import { Skeleton } from '@/shared/components/shadcn/skeleton';
import { cn } from '@/shared/utils/cn';

export function PlanCardSkeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'border-border flex min-h-px min-w-0 flex-1 grow animate-pulse flex-col items-start justify-start gap-8 self-stretch rounded-xl border bg-white p-8',
        className,
      )}
    >
      {/* Title and Description */}
      <div className="flex w-full flex-col gap-6">
        <div className="flex w-full flex-col gap-3">
          <Skeleton className="h-7 w-32 rounded-md" />
          <Skeleton className="h-10 w-full rounded-md" />
        </div>
        {/* Price */}
        <div className="flex w-full flex-row items-end gap-2">
          <Skeleton className="h-10 w-24 rounded-md" />
        </div>
        {/* Button */}
        <Skeleton className="h-10 w-full rounded-md" />
      </div>
      {/* Features */}
      <div className="flex w-full flex-col gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="flex w-full flex-row items-center gap-3">
            <Skeleton className="h-5 w-5 rounded-full" />
            <Skeleton className="h-5 flex-1 rounded-md" />
          </div>
        ))}
      </div>
    </div>
  );
}
